module.exports = __webpack_public_path__ + "static/media/26_shape_l.d04a97ee.webp";